import React from "react";
import { useNavigate } from "react-router-dom";

const PanelWithoutBlueShit = () => {

  const navigate = useNavigate();

  return (
    <div>
      <div
        className="relative w-full h-[250px] sm:h-[300px] flex md:items-end md:px-16 md:pb-24 items-center px-6 md:justify-start bg-cover bg-center"
        style={{ backgroundImage: "url('/bg1.png')" }}
      >
        <div className="absolute inset-0 cus-grad"></div>
        <h1 
          className="relative text-xl font-bold text-start text-white cursor-pointer sm:text-4xl"
        >
          BOOK TICKET NOW
        </h1>
      </div>
      
      {/* New Panel */}
    </div>
  );
};

export default PanelWithoutBlueShit;
